import type { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';
import { BloomreachProductType } from '../../hooks/use-search/use-search-types';

interface FilterButtonsSkeletonProps {
    productType?: BloomreachProductType;
}

/**
 * Skeleton component for FilterButtons.
 * Matches the layout structure of FilterButtons component.
 * Simplified version without negative margins - just maintains visual spacing.
 */
export const FilterButtonsSkeleton: FC<FilterButtonsSkeletonProps> = ({ productType }) => (
    <div className="w-full py-2 md:py-4" data-testid="search-filter-buttons-skeleton">
        <div className="scrollbar-hide flex w-full flex-row gap-2 overflow-x-auto overflow-y-hidden">
            {/* Hide Category and Brand filter buttons for recipes - only show "All Filters" button */}
            {productType !== BloomreachProductType.recipe &&
                Array.from({ length: 3 }, (_, index) => (
                    <Skeleton
                        key={`filter-button-${index}`}
                        height="40px"
                        width="120px"
                        borderRadius="4px"
                        className="shrink-0"
                    />
                ))}
            {/* All Filters button skeleton */}
            <Skeleton height="40px" width="120px" borderRadius="4px" className="shrink-0" />
            <div className="flex min-w-0 flex-1 justify-end">
                <Skeleton height="40px" width="180px" borderRadius="4px" className="shrink-0" />
            </div>
        </div>
    </div>
);
